export const getRequirementLabels = (metric) => {
    if (!metric) return [];

    const labels = [];
    const io = metric?.io || {};

    const addLabel = (value, label) => {
        if (!value) return;

        const isRequired = typeof value === 'string'
            ? value === 'required'
            : value?.required === true;

        if (isRequired) {
            labels.push(label);
        }
    };

    addLabel(io.source, 'Requires Source');
    addLabel(io.target, 'Requires Target');
    addLabel(io.reference, 'Requires Reference');

    return labels;
};

export const categorizeMetrics = (metrics) => {
    const categories = {
        standard: [],
        bertscore: [],
        comet: [],
        metricx: []
    };

    metrics.forEach(metric => {
        if (!metric || !metric.key) return;

        const id = metric.id?.toLowerCase() || metric.key.toLowerCase();
        const name = metric.name?.toLowerCase() || '';

        if (id.includes('bert') || name.includes('bertscore') || name.includes('bert')) {
            categories.bertscore.push(metric);
        } else if (id.includes('comet') || name.includes('comet')) {
            categories.comet.push(metric);
        } else if (id.includes('metric') || name.includes('metricx') || name.includes('metric')) {
            categories.metricx.push(metric);
        } else {
            categories.standard.push(metric);
        }
    });

    return categories;
};

function getSegmentTokens(seg, io) {
    let total = 0;

    if (io.reference === "required" && seg.reference) {
        total += seg.reference.length;
    }

    if (io.source === "required" && seg.source) {
        total += seg.source.length;
    }

    if (io.target === "required" && seg.target) {
        total += seg.target.length;
    }

    return total;
}

//NOT USED --16.03.2026
export function calculateDynamicBatchingEstimate({
    segments,
    maxTokensPerBatch,
    avgRequestTimeSec,
    pricePerHour,
    io,
}) {

    if (!Array.isArray(segments) || segments.length === 0) {
        return {
            batchCount: 0,
            totalTimeSec: 0,
            totalPrice: 0,
        };
    }

    let batches = [];
    let currentBatch = [];
    let currentTotal = 0;

    for (const seg of segments) {
        const segTokens = getSegmentTokens(seg, io);

        if (currentTotal + segTokens > maxTokensPerBatch) {
            batches.push(currentBatch);
            currentBatch = [];
            currentTotal = 0;
        }

        currentBatch.push(seg);
        currentTotal += segTokens;
    }

    if (currentBatch.length > 0) {
        batches.push(currentBatch);
    }

    const batchCount = batches.length;

    const totalTimeSec = batchCount * avgRequestTimeSec;
    console.log(1111, totalTimeSec);

    const pricePerBatch = pricePerHour * (avgRequestTimeSec / 3600);
    const totalPrice = Number((pricePerBatch * batchCount).toFixed(5));

    return {
        batchCount,
        totalTimeSec,
        totalPrice,
        batches,
    };
}



